module.exports = __webpack_public_path__ + "img/lead_slide5_md.0555d966.png";